module.exports = __webpack_public_path__ + "static/media/twitter.5c745d7b.8854f69e.svg";